import { accountDetails } from "@di";
import TransactionHistoryRepository from "@adapters/repositories/Reports/TransactionHistory";
import { downloadReportsRepo } from "@frameworks/web/components/Reports/understandingCommonDI/downloadReportsDI";
export default (http) => {
    return {
        transactionHistory: new TransactionHistoryRepository(http, accountDetails),
        downloadRepo: downloadReportsRepo,
    };
};
